import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import * as Styled from './styles'

interface ImportedInvoiceReviewCurrencySelectProps {
  disabled?: boolean
  error?: boolean
  id: string
  onSelect?: (currencyId?: string) => void
  selectedId?: string
}

export const ImportedInvoiceReviewCurrencySelect = ({
  disabled,
  error,
  id,
  onSelect,
  selectedId,
}: ImportedInvoiceReviewCurrencySelectProps): ReactElement => {
  const { t } = useTranslation()

  const handleSelect = useCallback(
    (currencyId?: string) => {
      onSelect?.(currencyId)
    },
    [onSelect],
  )

  return (
    <>
      <Styled.CurrencySelectLabel htmlFor={id}>
        {t('imported_invoices.review.form.currency')}
      </Styled.CurrencySelectLabel>
      <Styled.AmountCurrencySelect
        disabled={disabled}
        error={error}
        id={id}
        onSelect={handleSelect}
        selectedId={selectedId}
      />
    </>
  )
}
